const baseIp = {
  // baseURL: 'http://192.168.1.220:2018', //敏
  // baseURL: "http://192.168.3.222:2018" //彪
  // baseURL: 'http://192.168.1.48:2018', //亮
  // baseURL: "http://192.168.1.124:2018" //
  baseURL: 'https://api.edingzi.cn', //服务器
};
//访问路径
export const configIp = {
  baseURL: baseIp.baseURL + '/web/api/',
};



// WEBPACK FOOTER //
// ./src/api/base.js